import { render } from "./remove_follower_button.vue?vue&type=template&id=abcc0c7a"
import script from "./remove_follower_button.js?vue&type=script&lang=js&external"
export * from "./remove_follower_button.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__